import { ActionTypesFactory } from "../../common/redux/actions/ActionTypesFactory";

const agreementPermissionActionTypes = ActionTypesFactory.crudActionTypes(
  "AGREEMENT_PERMISSION"
);

export default agreementPermissionActionTypes;
